/**
 * Shipping cutoff countdown banner
 * - Counts down to today's cutoff time (e.g. 14:00) on weekdays
 * - Once passed, automatically counts down to tomorrow's cutoff instead
 * - On Friday after cutoff, and all day Saturday/Sunday, counts down to
 *   Monday's cutoff instead (we don't ship on weekends)
 * - Uses the customer's browser local time
 */

document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.shipping-countdown');
  if (!wrapper) return;

  const textEl = wrapper.querySelector('[data-shipping-countdown-text]');
  if (!textEl) return;

  const cutoffHour = parseInt(wrapper.dataset.cutoffHour, 10) || 14;
  const cutoffMinute = parseInt(wrapper.dataset.cutoffMinute, 10) || 0;
  const templateToday = wrapper.dataset.templateToday || 'Order within [hours] h [minutes] min for shipping today!';
  const templateTomorrow = wrapper.dataset.templateTomorrow || 'Order within [hours] h [minutes] min for shipping tomorrow!';
  const templateMonday = wrapper.dataset.templateMonday || 'Order within [hours] h [minutes] min for shipping on Monday!';

  function getNextMondayCutoff(base) {
    const target = new Date(base);
    const day = target.getDay(); // 0 = Sunday ... 6 = Saturday

    let daysToAdd;
    if (day === 0) {
      daysToAdd = 1; // Sunday -> Monday
    } else if (day === 6) {
      daysToAdd = 2; // Saturday -> Monday
    } else if (day === 5) {
      daysToAdd = 3; // Friday -> Monday
    } else {
      daysToAdd = (8 - day) % 7 || 7;
    }

    target.setDate(target.getDate() + daysToAdd);
    target.setHours(cutoffHour, cutoffMinute, 0, 0);
    return target;
  }

  function getNextCutoff() {
    const now = new Date();
    const day = now.getDay(); // 0 = Sunday ... 6 = Saturday

    // All day Saturday or Sunday: next cutoff is always Monday
    if (day === 0 || day === 6) {
      return { target: getNextMondayCutoff(now), type: 'monday' };
    }

    const todayCutoff = new Date(now);
    todayCutoff.setHours(cutoffHour, cutoffMinute, 0, 0);

    if (now < todayCutoff) {
      return { target: todayCutoff, type: 'today' };
    }

    // Cutoff has passed today
    if (day === 5) {
      // Friday after cutoff: next shipping day is Monday
      return { target: getNextMondayCutoff(now), type: 'monday' };
    }

    // Monday–Thursday after cutoff: next shipping day is tomorrow
    const tomorrowCutoff = new Date(todayCutoff);
    tomorrowCutoff.setDate(tomorrowCutoff.getDate() + 1);
    return { target: tomorrowCutoff, type: 'tomorrow' };
  }

  function pad(num) {
    return String(num).padStart(2, '0');
  }

  function render() {
    const { target, type } = getNextCutoff();
    const now = new Date();
    const diffMs = target - now;

    if (diffMs <= 0) {
      // Safety fallback: recompute immediately if we've just crossed the cutoff
      render();
      return;
    }

    const totalMinutes = Math.floor(diffMs / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    let template;
    if (type === 'today') {
      template = templateToday;
    } else if (type === 'tomorrow') {
      template = templateTomorrow;
    } else {
      template = templateMonday;
    }

    const message = template
      .replace('[hours]', '<strong>' + hours + '</strong>')
      .replace('[minutes]', '<strong>' + pad(minutes) + '</strong>');

    textEl.innerHTML = message;
  }

  render();
  setInterval(render, 30000);
});